import React, { useEffect } from "react";
import { Row, Column } from "components/Layout/Grid";
import Text from "components/Text";
import Input from "components/Input";
import Validator from "components/Validator";
import { IOccurrenceDate } from './interface';

const OccurrenceDate: React.FC<IOccurrenceDate> = (props) => {
  const {
    protocolCategory,
    occurrenceDate,
    setOccurrenceDate,
    isEditing
  } = props;

  useEffect(() => {
    if (!isEditing) {
      setOccurrenceDate('');
    }
  }, [protocolCategory]);

  return (
    <Row className="mt-5 flex-md-column">
      <Column className="flex-1 ml-md-0 mt-md-2">
        <Text className="mb-2 color-blue-gray" size={12}>
          Data da ocorrência
        </Text>
        <Validator value={occurrenceDate} name="Data da ocorrência" required={!occurrenceDate || occurrenceDate === 'dd/mm/aaaa'}>
          <Input
            stateName="occurrenceDate"
            onChange={(e: any) => setOccurrenceDate(e.target.value)}
            type="date"
            placeholder="Data"
            value={occurrenceDate}
          />
        </Validator>
      </Column>
    </Row>
  );
};

export default OccurrenceDate;
